angular.module('impactx.cscaccounting').controller('CSCAccountingCtrl', [
    '$scope',
    '$mdPanel',
    'dataGen',
    '$routeParams',
    'ToastService',
    'BackService',
    'ToolbarService',
    'PartialDialogsService',
    CSCAccountingCtrl
]);

function CSCAccountingCtrl($scope, $mdPanel, dataGen, $routeParams, ToastService, BackService, ToolbarService, PartialDialogsService) {
    var self = this;
    $scope.anchorMenuItems = [];
    self.shown = {};
    self.controls = {};

    self.openCopyContractControlsDialog = function (ev) {
        $mdPanel.open({
            id: 'copycontractcontrol',
            attachTo: angular.element(document.body),
            templateUrl: 'modules/cscaccounting/templates/cscaccounting-copy-control.panel.html',
            focusOnOpen: false,
            zIndex: 10,
            clickOutsideToClose: true,
            controller: 'CSCAccountingCopyControlPanelCtrl',
            controllerAs: 'cscAccountingCopyControlPanelCtrl',
            panelClass: 'menu-panel-container',
            animation: $mdPanel.newPanelAnimation()
                .openFrom("#copycontractcontrol")
                .closeTo("#copycontractcontrol")
                .withAnimation($mdPanel.animation.SCALE),
            position: $mdPanel.newPanelPosition()
                .relativeTo(angular.element("#copycontractcontrol"))
                .addPanelPosition(
                    $mdPanel.xPosition.CENTER,
                    $mdPanel.yPosition.BELOW
                ),
            locals: {
                trns: $scope.trns,
                currentCSCId: $routeParams.cscId,
                onClose: self.refreshControlsFromContract
            },
        });
    };

    self.refreshControlsFromContract = function (selectedContract) {
        if (selectedContract && selectedContract.id) {
            dataGen.getData({}, {cscId: selectedContract.id}, "/cscaccounting/view/control/all").then(function (data) {
                if (data.data) {
                    angular.copy(data.data.controls, $scope.data.controls);
                    $scope.data.controls.forEach((ctrl) => {
                        self.controls[ctrl.type] = ctrl;
                        self.shown[ctrl.type] = true;
                    });
                }
            });
        }
    };

    self.toggleControl = function(ctrl) {
        if(!self.controls[ctrl])
        {
            self.loadControl($routeParams.cscId, ctrl);
        }
        self.shown[ctrl] = !self.shown[ctrl];
    }

    self.loadControl = function (cscId, ctrl) {
        dataGen.getData({}, {cscId: cscId, control: ctrl}, "/cscaccounting/view/control").then(function (data) {
            if (data.data && !self.controls[ctrl]) {
                $scope.data.controls.push(data.data);
                self.controls[ctrl] = data.data;
            }
        });
    };

    self.saveData = function ($event) {
        return dataGen.postAsForm($scope, {formData: $scope.data}, "/cscaccounting/save").then(function () {
            ToastService.openStandardToast($scope.trns.saveSuccess);
            PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.CONTRACT, $routeParams.cscId, 'cscaccounting', $routeParams.preSetId ? $routeParams.preSetId : 0);
        });
    };

    self.getData = function (scope, cscId) {
        return dataGen.getData(scope, {cscId: cscId}, "/cscaccounting/view");
    };

    self.getData($scope, $routeParams.cscId).then(function () {
        for (var i = 0; i < $scope.data.controls.length; i++) {
            $scope.anchorMenuItems.push({id: 'control-relation-' + i, label: $scope.data.controls[i].control.label});
            self.controls[$scope.data.controls[i].type] = $scope.data.controls[i];
        }

        defineButtons();
    });

    self.deleteFallbackControl = function (cttControl) {
        cttControl.fallbackControl = undefined;
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.saveData,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.copyControlsOf,
                action: self.openCopyContractControlsDialog,
                type: 'dialogaction',
                id: "copycontractcontrol"
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }
}